import styled from 'styled-components';

export const CertName = styled.h6`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  letter-spacing: 2.6px;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 500;
  padding: ${(props) => (props.desktop ? '7px 0px' : '10px 12px 0')};
`;
